import { useEffect, useMemo, useState } from 'react'

import { SelectOptionGroups } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { SalaryErrors, validator } from './validations'

export interface SalaryConfig {
  min?: number
  max?: number
  gross?: number
}

export const useSalary = (nodeType: string, initialSalary?: SalaryConfig) => {
  const [minAmount, setMinAmount] = useState<string | undefined>(String(initialSalary?.min))
  const [maxAmount, setMaxAmount] = useState<string | undefined>(String(initialSalary?.max))
  const [grossSalary, setGrossSalary] = useState<string | undefined>(String(initialSalary?.gross))

  const [periodicity, setPeriodicity] = useState<string>('yearly')
  const salaryPeriodicityOptions: SelectOptionGroups = [
    {
      label: i18n.t('job_catalog.nodes.salary_modal.periodicities.yearly'),
      value: 'yearly',
    },
  ]

  const initialRange = useMemo(
    () => (grossSalary && grossSalary !== 'undefined' ? 'fixed' : 'range'),
    [grossSalary]
  )
  const [type, setType] = useState<string>(initialRange)
  const salaryTypeOptions: SelectOptionGroups = [
    {
      label: i18n.t('job_catalog.nodes.salary_modal.types.range'),
      value: 'range',
    },
    {
      label: i18n.t('job_catalog.nodes.salary_modal.types.fixed'),
      value: 'fixed',
    },
  ]

  const isTypeAvailable = useMemo(() => ['role', 'level'].includes(nodeType), [nodeType])
  const isTypeRange = useMemo(() => type === 'range', [type])

  const [errors, setErrors] = useState<SalaryErrors>({})

  const validate = useMemo(() => validator(setErrors), [setErrors])

  useEffect(() => {
    validate(Number(minAmount), Number(maxAmount), Number(grossSalary))
  }, [minAmount, maxAmount, grossSalary, validate])

  const isValid = useMemo(() => {
    if (Object.keys(errors).length !== 0) return false
    if (isTypeRange) return minAmount && maxAmount
    return grossSalary
  }, [minAmount, maxAmount, grossSalary, isTypeRange, errors])

  return {
    minAmount,
    maxAmount,
    grossSalary,
    periodicity,
    salaryPeriodicityOptions,
    type,
    salaryTypeOptions,
    isTypeAvailable,
    isTypeRange,
    isValid,
    errors,
    setMinAmount,
    setMaxAmount,
    setGrossSalary,
    setPeriodicity,
    setType,
  }
}
